import global$1 from './global.js';
import isArray$1 from './is-array.js';
import isConstructor$1 from './is-constructor.js';
import isObject$1 from './is-object.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var global = global$1;
var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$1;
var wellKnownSymbol = wellKnownSymbol$1;
var SPECIES = wellKnownSymbol('species');
var Array = global.Array; // a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesConstructor = function (originalArray) {
  var C;

  if (isArray(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? Array : C;
};

export { arraySpeciesConstructor as default };
